import { useCallback, useMemo, useState } from 'react'

type UseNavigationSectionStateProps = {
    stateStorageKey: string
}

export function useNavigationSectionState({ stateStorageKey }: UseNavigationSectionStateProps) {
    const [isCollapsed, setIsCollapsed] = useState(restoreCollapsedState(stateStorageKey))

    const toggleIsCollapsed = useCallback(() => {
        setIsCollapsed((prev) => {
            const newState = !prev
            persistCollapsedState(stateStorageKey, newState)

            return newState
        })
    }, [stateStorageKey])

    return useMemo(
        () => ({
            isCollapsed,
            toggleIsCollapsed,
        }),
        [isCollapsed, toggleIsCollapsed]
    )
}

function persistCollapsedState(key: string, isCollapsed: boolean) {
    localStorage.setItem(key, (!isCollapsed).toString())
}

function restoreCollapsedState(key: string) {
    const value = localStorage.getItem(key)

    return value ? value === 'false' : false
}
